import React, { useState } from "react";
import { FullScreenDialog } from "../../core/FullScreenDialog";
import { SmartTextField } from "../../core/SmartTextField";
import { useGameIdFromRoute } from "../WithGameIdFromRoute";
import { useEditGameTask, useDeleteGameTask } from "@seabrookstudios/pitch2table";
import { enqueueSnackbar } from "notistack";
import EditIcon from "@mui/icons-material/Edit";
import { sanitiseTaskName, TaskMaxLength } from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Task} props.task
 */
export const EditTaskDialog = ({ task }) => {
  const [taskName, setTaskName] = useState(task.name);
  const gameId = useGameIdFromRoute();

  const onSaveSuccess = () => {
    enqueueSnackbar("Task updated successfully", { variant: "success" });
  };
  const onSaveFailure = () => {
    enqueueSnackbar("Failed to update task", { variant: "error" });
  };
  const onDeleteSuccess = () => {
    enqueueSnackbar("Task deleted successfully", { variant: "success" });
  };
  const onDeleteFailure = () => {
    enqueueSnackbar("Failed to delete task", { variant: "error" });
  };

  const editTask = useEditGameTask(gameId, task.id, onSaveSuccess, onSaveFailure);
  const deleteTask = useDeleteGameTask(gameId, task.id, onDeleteSuccess, onDeleteFailure);

  const handleSave = async () => {
    await editTask.mutateAsync({
      name: taskName.trim(),
      order: undefined,
      status: undefined,
    });
  };

  const handleDelete = async () => {
    await deleteTask.mutateAsync();
  };

  const handleTaskNameChange = (value) => {
    setTaskName(value);
  };

  const canSave = taskName.trim() === "";

  return (
    <FullScreenDialog
      title="Edit Task"
      actionText="Save"
      canSave={canSave}
      onSaveHandler={handleSave}
      Icon={EditIcon}
      onDeleteHandler={handleDelete}
    >
      <SmartTextField
        label="Task Name"
        initialValue={task.name}
        onChange={handleTaskNameChange}
        sanitize={sanitiseTaskName}
        maxLength={TaskMaxLength}
        required
        autoFocus
      />
    </FullScreenDialog>
  );
};
